import React from "react";
import Career from "../../componentLayer/pages/career/Career.jsx";
import Description from "../../componentLayer/pages/career/Description.jsx";
import SkillAccelerator from "../../componentLayer/pages/career/SkillAccelerator/SkillAccelerator.jsx";
import Bootcamp from '../../componentLayer/pages/career/Bootcamp.jsx'

export const CareerRouter = [
  {
    
    index:true,
    element: <Career />,
  },

  {
 
    children: [
      { index: true, element: <Career /> },
      { path: "position_description/:id", element: <Description/> },
      {
        path: "infor-cloud-suite-bootcamp/apply",
        element: <Bootcamp />,
      },
      {
        path: "internal-hiring-program/job-connector-bootcamp",
        element: <Career />,
      },
      {
        path: "internal-hiring-program/skill-accelerator-bootcamp",
        element: <SkillAccelerator />,
      },
    ],
  },
];
